import { normalizeFilterValues } from './filter-codec';
import type { ListQuery } from './types';

/** Trimmed text, or undefined when blank: the URL never carries empty params. */
export function nonEmpty(value: string | undefined | null): string | undefined {
  const trimmed = value?.trim();
  return trimmed === '' ? undefined : trimmed;
}

export function applyListPatch(prev: ListQuery, patch: Partial<ListQuery>): ListQuery {
  return {
    q: 'q' in patch ? nonEmpty(patch.q) : prev.q,
    sort: 'sort' in patch ? nonEmpty(patch.sort) : prev.sort,
    filters: patch.filters ? normalizeFilterValues(patch.filters) : prev.filters,
  };
}
